import axios from '../axios'

var DataloggerProvider = function () {
  return {
    GetInServiceDataloggersWithoutSignOfLife () {
      return axios.get('/datalogger/GetInServiceDataloggersWithoutSignOfLife')
    }
  }
}
export default new DataloggerProvider()



// WEBPACK FOOTER //
// ./src/providers/DataloggerProvider.js